import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";

import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';

import {  Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const QualityStockFollowUpViewByConsumble = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [consumble, setConsumble] = useState([]);
    const [permission, setPermission] = useState({});
      let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(455)); 
console.log(permission);

    axios
      .get(`/stock-follow-ups/listing-groupby/consumable/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.stocks_groupby);
        setConsumble(response.data.data.consumable_detail);
       

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const columns =
  [
   
    {
      accessorKey: 'supplier_name', //normal accessorKey
      header: 'Supplier Name',
    },
    {
      accessorKey: 'location_name', //normal accessorKey
      header: 'Location Name',
    },
    {
      accessorKey: 'operation', //normal accessorKey
      header: 'Operation',
    },
    {
      accessorKey: 'total_quantity', //normal accessorKey
      header: 'Total Quanities',
    },
    {
      accessorKey: 'stock_situation', //normal accessorKey
      header: 'Stock Situation',
    },
   
 
   ];


 
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Stock Situation by Consumable </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/stock-situations">Stock Situations</Link>
                    </li>
                    <li className="breadcrumb-item active">View</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Stock Situations Infornamtion</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th  className="p-3">Consumble Name</th>
                        <td className="p-3">{consumble.consumable_name}</td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Supplier </th>
                        <td className="p-3">
                          {consumble.supplier_detail ? consumble.supplier_detail.name : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Average Level</th>
                        <td className="p-3">{consumble.average_level}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Critical Level</th>
                        <td className="p-3">{consumble.critical_level}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Description</th>
                        <td className="p-3">{consumble.description}</td>
                      </tr>

                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                      <div className="table-responsive">
                          <MaterialReactTable columns={columns} data={data} 
                              enableColumnOrdering
                              enablePinning
                            />
                          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityStockFollowUpViewByConsumble;
